import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Form, Input, Label, Row } from "reactstrap";
import { Btn, H2, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import {
  EmailAddress,
  ForgotPasswordText,
  Password,
  RememberPassword,
  SignIn,
  SignInAccount,
} from "../../utils/Constant";

import { useLogin, useProfileData } from "./useAuth";

const Login = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  // Call the useLogin hook
  const loginMutation = useLogin();

  const { refetch: profileData } = useProfileData();

  const SimpleLoginHandle = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Call the mutate function from useMutation
    loginMutation.mutate(
      { username: email, password }, // Pass credentials as an object

      {
        onSuccess: (data) => {
          // console.log("Login successful:", data);
          // getProfileData.refetch();\
          // queryClient.invalidateQueries({ queryKey: ["USER_PROFILE"] });
          profileData().then((data) => {
            localStorage.setItem("Profile",JSON.stringify(data.data.data));
            toast.success("Login successful!");
            navigate('/dashboard/default');
          })
          .catch(e =>{
            toast.error('Login Failed, Please try again.');
            localStorage.removeItem('Apptoken')
            localStorage.removeItem('User')
          })
        },
        onError: (error) => {
          console.error("Login failed:", error);
        },
      }
    );
  };

  console.log('LOGIN')

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to="#">
                  <Image
                    style={{ width: "25%" }}
                    src={dynamicImage("logo/Truesales.png")}
                    alt="logo"
                  />
                </Link>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={SimpleLoginHandle}>
                  <H2 className="text-center">{SignInAccount}</H2>
                  <P className="text-center">
                    {"Enter your email & password to login"}
                  </P>
                  <div className="form-group">
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input
                      type="email"
                      required
                      placeholder="Enter Email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Input
                        type={show ? "text" : "password"}
                        placeholder="Enter Password"
                        onChange={(event) => setPassword(event.target.value)}
                        value={password}
                      />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 checkbox-checked">
                    <div className="form-check checkbox-solid-info">
                      {/* <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" htmlFor="checkbox1">
                        {RememberPassword}
                      </Label> */}
                      <Link to={'/forgotPassword'} >
                        {" "}
                        {ForgotPasswordText}
                      </Link>
                    </div>
                    <div className="text-end mt-3">
                      <Btn color="primary" block className="w-100">
                        {SignIn}
                      </Btn>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
